import { colors, textSizes, weights } from '@components/theme/styles/index';
import { Breadcrumbs, BreadcrumbsProps, styled } from '@mui/material';
import { rem } from 'polished';

type CustomBreadcrumbsProps = {
  $isMobile?: boolean;
  $isBrandingEnabled?: boolean;
  $mainColor?: string;
};

const getColor = (
  isMobile: boolean,
  isBrandingEnabled: boolean,
  mainColor: string,
) => {
  if (isMobile) {
    if (isBrandingEnabled) {
      return mainColor;
    }
    return colors.primary;
  }
  return colors.grayDark2;
};

export const StyledLink = styled('a', {
  shouldForwardProp: (prop) =>
    prop !== '$isMobile' &&
    prop !== '$isBrandingEnabled' &&
    prop !== '$mainColor',
})<CustomBreadcrumbsProps>(({ $isMobile, $isBrandingEnabled, $mainColor }) => ({
  textDecoration: 'none',
  color: getColor($isMobile, $isBrandingEnabled, $mainColor),
  cursor: $isMobile ? 'unset' : 'pointer',
  // prevent default link behavior
  pointerEvents: $isMobile ? 'none' : 'auto',
  '&:hover': {
    color: colors.tertiary,
  },
}));

export const StyledSpan = styled('span', {
  shouldForwardProp: (prop) => prop !== '$isMobile',
})<CustomBreadcrumbsProps>(({ $isMobile }) => ({
  color: $isMobile ? colors.textColors4 : colors.gray,
}));

export const StyledBreadcrumbs = styled(Breadcrumbs, {
  shouldForwardProp: (prop) => prop !== '$isMobile',
})<CustomBreadcrumbsProps & BreadcrumbsProps>(({ $isMobile }) => ({
  '&.MuiBreadcrumbs-root': {
    fontSize: $isMobile ? rem(14) : rem(textSizes.sm1),
    fontWeight: $isMobile ? weights.medium : weights.normal,
    color: colors.grayDark2,
  },
  '& .MuiBreadcrumbs-separator': {
    fontSize: rem(textSizes.sm),
    color: $isMobile ? colors.textColors6 : colors.grayDark2,
  },
}));
